// extracted by mini-css-extract-plugin
export var aniSpin = "ProfilesGrid-module--ani-spin--w5eCd";
export var column = "ProfilesGrid-module--column--g+cvV";
export var grid = "ProfilesGrid-module--grid--7Dqvy";
export var heading = "ProfilesGrid-module--heading--0cWxo";
export var item__image = "ProfilesGrid-module--item__image--7pXY8";
export var item__name = "ProfilesGrid-module--item__name--IeeYx";
export var item__role = "ProfilesGrid-module--item__role--ew9YZ";